// extracted by mini-css-extract-plugin
export default {"wave":"WavesBackground_wave__g5P1C","waveRotate":"WavesBackground_waveRotate__XSUAm"};